<div class="layout">
  <!-- Sidebar -->
  <app-sidebar-nav class="basis-0" />
  
  <div class="layout__body">
    <!-- Top nav spans full width -->
    <app-top-nav />
    <main class="bg-[#EEF3F9] grow overflow-auto">
        <router-outlet></router-outlet>
    </main>
  </div>
</div>
